import { z } from 'zod';

export const OrgIdSchema = z.string().regex(/^[a-f\d]{24}$/i, 'must be a 24-char hex ObjectId');

export type OrgId = z.infer<typeof OrgIdSchema>;
